import { Chapter, ChapterType } from "graphql/types"
import { v4 } from "uuid"

export const reportEUTChapterTemplate: Chapter = {
  id: v4(),
  type: ChapterType.EUT,
  name: "Equipment Under Test (EUT)",
  chapterNumber: "3",
  subChapter: [
    {
      id: v4(),
      type: ChapterType.EUT_EUT,
      name: "Description of EUT",
      chapterNumber: "3.1",
      subChapter: [],
      open: false,
      data: [],
    },
    {
      id: v4(),
      type: ChapterType.EUT_AUX,
      name: "Description of Auxiliary Equipment (AE)",
      chapterNumber: "3.2",
      subChapter: [],
      open: false,
      data: [],
    },
    {
      id: v4(),
      type: ChapterType.EUT_ENTRANCE_EXAMEN,
      name: "Entrance Examination",
      chapterNumber: "3.3",
      subChapter: [],
      open: false,
      data: [],
    },
    {
      id: v4(),
      type: ChapterType.EUT_CONNECTIONS,
      name: "Description of Connections",
      chapterNumber: "3.4",
      subChapter: [],
      open: false,
      data: [],
    },
    {
      id: v4(),
      type: ChapterType.EUT_FUNCTIONAL_CHECKS,
      name: "Description of Functional Checks",
      chapterNumber: "3.5",
      subChapter: [],
      open: false,
      data: [],
    },
    {
      id: v4(),
      type: ChapterType.EUT_GENERAL_PASS_FAIL_CRITERIA,
      name: "Description of general Pass / Fail Criteria for Immunity tests",
      chapterNumber: "3.6",
      subChapter: [],
      open: false,
      data: [],
    },
  ],
  open: false,
  data: [],
}

export const reportChaptersTemplate: Chapter[] = [
  {
    id: v4(),
    type: ChapterType.INDEX,
    name: "Index",
    chapterNumber: "1",
    subChapter: [],
    open: false,
    data: [],
  },
  {
    id: v4(),
    type: ChapterType.OVERVIEW,
    name: "Test Overview and Results",
    chapterNumber: "2",
    subChapter: [],
    open: false,
    data: [],
  },

  reportEUTChapterTemplate,

  {
    id: v4(),
    type: ChapterType.APPENDIX_A,
    name: "Applied Conformity Assessment Rule",
    chapterNumber: "Appendix A",
    subChapter: [],
    open: false,
    data: [],
  },
]

export const reportTestChapterTemplate: Chapter = {
  id: v4(),
  type: ChapterType.TEST,
  name: "Header of Test - Prüfungen",
  chapterNumber: "4",
  subChapter: [
    {
      id: v4(),
      type: ChapterType.TEST_SPECIFICATIONS,
      name: "Test Specifications",
      chapterNumber: "4.1",
      subChapter: [
        {
          id: v4(),
          type: ChapterType.TEST_SPECIFICATIONS_ADAPTED_STANDARD,
          name: "Adapted Standard",
          chapterNumber: "4.1.1",
          subChapter: [],
          open: false,
          data: [],
        },
        {
          id: v4(),
          type: ChapterType.TEST_SPECIFICATIONS_QTP,
          name: "Qualification Test Plan",
          chapterNumber: "4.1.2",
          subChapter: [],
          open: false,
          data: [],
        },
        {
          id: v4(),
          type: ChapterType.TEST_SPECIFICATIONS_PARAMETER_AND_CATEGORY,
          name: "Test Parameters / Category",
          chapterNumber: "4.1.3",
          subChapter: [],
          open: false,
          data: [],
        },
        {
          id: v4(),
          type: ChapterType.TEST_SPECIFICATIONS_DEVITATIONS,
          name: "Deviations",
          chapterNumber: "4.1.4",
          subChapter: [],
          open: false,
          data: [],
        },
        {
          id: v4(),
          type: ChapterType.TEST_SPECIFICATIONS_REMARKS,
          name: "Remarks",
          chapterNumber: "4.1.5",
          subChapter: [],
          open: false,
          data: [],
        },
        {
          id: v4(),
          type: ChapterType.TEST_SPECIFICATIONS_PASS_FAIL_CRITERIA,
          name: "Pass/Fail Criteria",
          chapterNumber: "4.1.6",
          subChapter: [],
          open: false,
          data: [],
        },
      ],
      open: false,
      data: [],
    },
    {
      id: v4(),
      type: ChapterType.TEST_LOCATION_AND_CONDITIONS,
      name: "Test Location and Conditions",
      chapterNumber: "4.2",
      subChapter: [],
      open: false,
      data: [],
    },
    {
      id: v4(),
      type: ChapterType.TEST_EQUIPMENT,
      name: "Test Equipment",
      chapterNumber: "4.3",
      subChapter: [],
      open: false,
      data: [],
    },
    {
      id: v4(),
      type: ChapterType.TEST_EXTERNAL_WITNESS,
      name: "External Witnessing Persons",
      chapterNumber: "4.4",
      subChapter: [],
      open: false,
      data: [],
    },
    {
      id: v4(),
      type: ChapterType.TEST_SETUP,
      name: "Test Set-Up",
      chapterNumber: "4.5",
      subChapter: [],
      open: false,
      data: [],
    },
    {
      id: v4(),
      type: ChapterType.TEST_RESULTS,
      name: "Results",
      chapterNumber: "4.6",
      subChapter: [],
      open: false,
      data: [],
    },
  ],
  open: false,
  data: [],
}

export const getChapterName = (type: ChapterType) => {
  switch (type) {
    case ChapterType.EUT:
      return "2 Equipment Under Test (EUT)"
    case ChapterType.EUT_EUT:
      return "2.1 Description of EUT"
    case ChapterType.EUT_AUX:
      return "2.2 Description of Auxiliary Equipment (AE)"
    case ChapterType.EUT_ENTRANCE_EXAMEN:
      return "2.3 Entrance Examination"
    case ChapterType.EUT_CONNECTIONS:
      return "2.4 Description of Connections"
    case ChapterType.EUT_FUNCTIONAL_CHECKS:
      return "2.5 Description of Functional Checks"
    case ChapterType.EUT_GENERAL_PASS_FAIL_CRITERIA:
      return "2.6 Description of general Pass / Fail Criteria for Immunity tests"
    case ChapterType.INDEX:
      return "0 Index"
    case ChapterType.OVERVIEW:
      return "1 Test Overview and Results"
    case ChapterType.TEST:
      return "3 Header of Test - Prüfungen"
    case ChapterType.TEST_SPECIFICATIONS:
      return "3.1 Test Specifications"
    case ChapterType.TEST_SPECIFICATIONS_ADAPTED_STANDARD:
      return "3.1.1 Adapted Standard"
    case ChapterType.TEST_SPECIFICATIONS_QTP:
      return "3.1.2 Qualification Test Plan"
    case ChapterType.TEST_SPECIFICATIONS_PARAMETER_AND_CATEGORY:
      return "3.1.3 Test Parameters / Category"
    case ChapterType.TEST_SPECIFICATIONS_DEVITATIONS:
      return "3.1.4 Deviations"
    case ChapterType.TEST_SPECIFICATIONS_REMARKS:
      return "3.1.5 Remarks"
    case ChapterType.TEST_SPECIFICATIONS_PASS_FAIL_CRITERIA:
      return "3.1.6 Pass/Fail Criteria"
    case ChapterType.TEST_LOCATION_AND_CONDITIONS:
      return "3.2 Test Location and Conditions"
    case ChapterType.TEST_EQUIPMENT:
      return "3.3 Test Equipment"
    case ChapterType.TEST_EXTERNAL_WITNESS:
      return "3.4 External Witnessing Persons"
    case ChapterType.TEST_SETUP:
      return "3.5 Test Set-Up"
    case ChapterType.TEST_RESULTS:
      return "3.6 Results"
    case ChapterType.APPENDIX:
      return "Appendix"
    case ChapterType.APPENDIX_A:
      return "Appendix A - Description of Applied Conformity Assessment Rule"

    case ChapterType.OWN_CHAPTER:
      return "Own Chapter"

    default:
      return "Unknown Chapter Type"
  }
}

export const deletableChapterTypes = [
  ChapterType.OWN_CHAPTER,
  ChapterType.APPENDIX,
  ChapterType.EUT_GENERAL_PASS_FAIL_CRITERIA,
]

export const editableChapterTypes = [
  ChapterType.OWN_CHAPTER,
  ChapterType.APPENDIX,
  ChapterType.TEST,
]
